export const headerComptable = {
  title: "Comptable",
  submodules: [
      createData(0, "Décomptes des missions", "/accounting/decompte"),
      createData(1, "Paramétrage des indemnités", "/accounting/setting_indemnity"),
      createData(1, "Indemnités Mission", "/accounting/indemnity_mission")
  ],
};

function createData(id, moduleName, ref) {
  return { id, moduleName, ref };
}